export var EWindowEvents;
(function (EWindowEvents) {
    EWindowEvents["LogIn"] = "logInEvent";
    EWindowEvents["LogOut"] = "logOutEvent";
    EWindowEvents["ClearSession"] = "clearSession";
    EWindowEvents["SessionExpired"] = "sessionExpired";
    EWindowEvents["RefreshMemberProfileInSession"] = "refreshMemberProfileInSession";
    EWindowEvents["TriggerLogIn"] = "triggerLogIn";
    // Auth0 checking is done and is not a member session.
    EWindowEvents["LoggedInAsGuest"] = "loggedInAsGuest";
    // Auth0 checking is done and member has already set in localStorage from previous request.
    EWindowEvents["LoggedInAlready"] = "loggedInAlready";
    // Auth0 checking is done and has problem to retrieve member data.
    EWindowEvents["LoggedInWithException"] = "loggedInWithException";
})(EWindowEvents || (EWindowEvents = {}));
